export default __webpack_public_path__ + "static/media/theme-aurora.d2c55b19.png";